import { render, staticRenderFns } from "./workshop-detail.vue?vue&type=template&id=cd918980&"
import script from "./workshop-detail.vue?vue&type=script&lang=js&"
export * from "./workshop-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports